export const GET_JOB_CODES = 'GET_JOB_CODES'
export const GET_JOB_CODES_FAILED = 'GET_JOB_CODES_FAILED'
export const GET_JOB_CODES_SUCCEEDED = 'GET_JOB_CODES_SUCCEEDED'

export const CREATE_JOB_CODE = 'CREATE_JOB_CODE'
export const CREATE_JOB_CODE_FAILED = 'CREATE_JOB_CODE_FAILED'
export const CREATE_JOB_CODE_SUCCEEDED = 'CREATE_JOB_CODE_SUCCEEDED'
